import { createFileRoute } from "@tanstack/react-router";

import { CollectionsPage } from "../../../workspaces/production/pages/CollectionsPage";

/** Every collection the floor runs, from every project that asked for one. */
export const Route = createFileRoute("/_console/production/collections")({
  component: CollectionsPage,
});
